import { memo } from 'react';
import { useUIV2Safe } from '@/contexts/UIV2Context';
import { cn } from '@/lib/utils';

interface GridOverlayProps {
  className?: string;
  size?: number;
  fadeEdges?: boolean;
}

/**
 * Standalone grid overlay component
 * Use when you need just the grid without full background layers
 */
export const GridOverlay = memo(function GridOverlay({ 
  className,
  size = 40,
  fadeEdges = true,
}: GridOverlayProps) {
  const { isLowFx, uiV2Enabled } = useUIV2Safe();
  
  if (!uiV2Enabled || isLowFx) return null;
  
  return (
    <div 
      className={cn(
        'v2-grid-overlay absolute inset-0 pointer-events-none',
        className
      )}
      style={{
        backgroundImage: `
          linear-gradient(hsl(var(--primary) / var(--grid-opacity)) 1px, transparent 1px),
          linear-gradient(90deg, hsl(var(--primary) / var(--grid-opacity)) 1px, transparent 1px)
        `,
        backgroundSize: `${size}px ${size}px`,
        ...(fadeEdges && {
          maskImage: 'radial-gradient(ellipse 80% 50% at 50% 50%, black 0%, transparent 70%)',
          WebkitMaskImage: 'radial-gradient(ellipse 80% 50% at 50% 50%, black 0%, transparent 70%)',
        }),
      }}
      aria-hidden="true"
    />
  );
});
